/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsListCountries204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsListCountries505Schema = z.any();

export const optionsListCountriesMutationResponseSchema = z.lazy(() => optionsListCountries204Schema);
